<template>
  <v-container id="clientEvents" class="px-0 pt-4" v-if="isAuthed">
    <v-row dense v-if="isReady">
      <v-tabs grow show-arrows
        v-model="store.tabPos"
        background-color="transparent"
        color="secondary">
        <v-tab @click="select('')">全て</v-tab>
        <v-tab @click="select('航空券')">航空券</v-tab>
        <v-tab @click="select('査証')">査証</v-tab>
        <v-tab @click="select('保険')">保険</v-tab>
        <v-tab @click="select('学校')">学校</v-tab>
      </v-tabs>
    </v-row>
    <v-divider v-if="isReady" class="mb-4"></v-divider>
    <v-row dense justify="center" class="pt-4">
      <v-col cols="12" v-if="isReady">
        <v-toolbar flat
          class="mx-auto transparent"
          max-width="600">
          <v-row dense>
            <v-col cols="4">
              <v-menu offset-y
                v-model="config.datepicker"
                transition="scale-transition"
                min-width="290px"
                :close-on-content-click="false"
                :nudge-right="40">
                <template v-slot:activator="{ on }">
                  <v-text-field readonly outlined
                    v-model="printMinDateFormat"
                    v-on="on"
                    label="予定日"
                    :append-icon="form.minDate ? 'fal fa-times' : null"
                    @click:append="form.minDate = ''"
                  />
                </template>
                <v-date-picker
                  v-model="form.minDate"
                  locale="ja"
                  color="amber"
                  :day-format="date => new Date(date).getUTCDate()"
                  @input="config.datepicker = false"
                  @change="submit({ type: 'get' })"
                />
              </v-menu>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="4">
              <v-select outlined
                v-model="form.sort.field"
                label="並び順"
                :items="getSortFieldMetaItems"
              />
            </v-col>
          </v-row>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row dense justify="center">
      <v-col cols="12" v-if="isReady">
        <v-list class="mx-auto py-0 mb-4" max-width="600">
          <v-list-item @click="openInserter">
            <v-list-item-avatar>
              <v-icon small class="secondary--text">fal fa-plus</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="secondary--text">追加する</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="12" v-if="!isReady">
        <v-list class="mx-auto py-0 transparent" max-width="500">
          <v-list-item>
            <v-progress-linear indeterminate color="secondary" />
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="12" v-if="isReady">
        <v-list class="mx-auto py-0 transparent" max-width="600">
          <template v-for="item in getItems">
            <v-divider :key="`div_${item.id}`" />
            <v-skeleton-loader v-if="isLoading" :key="item.id" type="list-item-avatar-two-line"></v-skeleton-loader>
            <Poster v-else :key="item.id" :item="item" @emit="emitted" />
          </template>
        </v-list>
      </v-col>
    </v-row>
    <Editor
      ref="editor"
      :type="'event'"
      :cid="getClientId"
      :fixed="true"
      @done="update"
    />
  </v-container>
</template>
<script>
import Editor from '@/components/calendar/modals/editor'
import Poster from './poster'
export default {
  name: 'clientEvents',
  components: {
    Editor,
    Poster
  },
  data () {
    return {
      config: {
        status: {
          authed: false,
          loading: false,
          ready: false
        },
        datepicker: false
      },
      meta: {
        sort: {
          fields: {
            scheduled: '予定日',
            created: '作成日'
          }
        }
      },
      form: {
        minDate: new Date().toISOString().substr(0, 10),
        sort: {
          field: 'scheduled',
          order: 'ASC'
        },
        filter: ''
      },
      store: {
        items: [],
        arranges: [],
        tabPos: null
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.$set(this.store, 'items', [])
      this.auth()
      this.submit({ type: 'get' })
      this.submit({ type: 'arranges' })
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$router.push(`/client/${this.$route.params.id}/about`)
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    },
    preSubmit: function (req) {
      const { type, status, item } = req
      const { minDate } = this.form
      const cid = this.$route.params.id
      const urls = {
        get: `${this.$url.api}calendar/get/client/${cid}`,
        arranges: `${this.$url.api}client/get/arranges/${cid}`
      }
      const fds = {
        get: { minDate },
        arranges: { cid }
      }
      if (type && urls[type] && fds[type]) {
        this.$set(this.config.status, 'loading', true)
        return { type, url: urls[type], fd: fds[type] }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { type, url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({
                type,
                data: res.data.data
              })
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const { type, data } = req || {}
      if (type === 'arranges') {
        this.$set(this.config.status, 'loading', false)
        this.$set(this.store, 'arranges', data)
      } else if (type === 'get') {
        this.$set(this.config.status, 'loading', false)
        this.$set(this.store, 'items', data.items)
        this.$set(this.config.status, 'ready', true)
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    },
    update: function (req) {
      const { type, data } = req || {}
      if (type === 'insert') {
        this.$set(this.store, 'items', this.store.items.concat(data || []))
      } else if (type === 'update') {
        if (data && data.id) {
          let idx = this.store.items.findIndex(it => { return it.id === data.id })
          if (idx >= 0) {
            this.store.items.splice(idx, 1, data)
          }
        }
      } else if (type === 'remove') {
        if (data && data.id) {
          let idx = this.store.items.findIndex(it => { return it.id === data.id })
          if (idx >= 0) {
            this.store.items.splice(idx, 1)
          }
        }
      }
    },
    edit: function (item) {
      this.openUpdater(item)
    },
    select: function (category) {
      this.$set(this.form, 'filter', category || '')
    },
    openUpdater: function (item) {
      if (item && item.id) {
        let idx = this.store.items.findIndex(it => { return it.id === item.id })
        if (idx >= 0) {
          let it = this.store.items[idx]
          const { reminders } = it || {}
          const { overrides } = reminders || {}
          const { arrange, category, label, createdby } = (it && it.extendedProperties && it.extendedProperties.private) ? it.extendedProperties.private : {}
          this.$refs.editor.open({
            type: 'update',
            event: it
          })
        }
      }
    },
    openInserter: function () {
      this.$refs.editor.open({ type: 'insert', event: {} })
    },
    minutes2duration: function (minutes) {
      if (minutes != null) {
        if (minutes >= 10080) {
          return `w${minutes / 10080}`
        } else if (minutes >= 1440) {
          return `d${minutes / 1440}`
        } else {
          return `min${minutes}`
        }
      } else {
        return ''
      }
    }
  },
  computed: {
    isAuthed () {
      return this.config.status.authed
    },
    isLoading () {
      return this.config.status.loading
    },
    isReady () {
      return this.config.status.ready
    },
    isEmpty () {
      return !this.store.items.length
    },
    printMinDateFormat () {
      return this.form.minDate ? `${this.$moment(this.form.minDate).format('YYYY/MM/DD')}〜` : ''
    },
    getClientId () {
      return this.$route.params.id
    },
    getSortFieldMetaItems () {
      return Object.keys(this.meta.sort.fields).map(key => {
        return {
          text: this.meta.sort.fields[key],
          value: key
        }
      })
    },
    getItems () {
      const { field } = this.form.sort
      return this.store.items.length ? this.store.items.filter(it => {
        const { category } = (it.extendedProperties && it.extendedProperties.private) ? it.extendedProperties.private : {}
        return !this.form.filter || category === this.form.filter
      }).map(it => {
        return Object.assign(it, {
          scheduled: this.$moment(it.start.date || it.start.dateTime || '').format('YYYY年MM月DD日')
        })
      }).sort((a, b) => {
        return a[this.form.sort.field] > b[this.form.sort.field] ? 1 : -1
      }) : []
    },
    getArrangeItems () {
      return this.store.arranges.length ? this.store.arranges.map(it => {
        return {
          text: it.title || '',
          value: it.id || ''
        }
      }) : []
    }
  }
}
</script>